

import { DadosUsuarioService } from 'src/app/services/dados-usuario.service';
import { BaseFormService } from './../../services/base-form.service';
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs/internal/operators/take';
import { AlertErroComponent } from '../alert-erro/alert-erro.component';
import { AlertSucessoComponent } from '../alert-sucesso/alert-sucesso.component';
import { FormsModule } from '@angular/forms';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { UpperCasePipe } from '@angular/common';

@Component({
    selector: 'app-alert-novo-departamento',
    templateUrl: './alert-novo-departamento.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AlertErroComponent, AlertSucessoComponent, FormsModule, PopoverDirective, UpperCasePipe]
})
export class AlertNovoDepartamentoComponent implements OnInit {

  @Input() alertIncluirDepartamento: boolean = false;
  @Output() alertIncluirDepartamentoFechou = new EventEmitter( );

  public novoDepartamento : string;
  public listaDepartamento : Array<string> = [];
  public listaDepartamentosEnviados: Array<string> = [];
  public idEmpresa: any;
  public resposta: any;
  public procuraDepartamento: number;

  public alertErro: boolean = false;
  public mensagemErro: any;

  public alertSucesso: any;
  public alertSucessoMensagem: any = "Sucesso ao criar novo departamento!";
  public alertSucessoSubtitulo: any = "";

  constructor(private readonly dadosUsuarioService: DadosUsuarioService,
              private readonly baseFormService: BaseFormService,) { }

  ngOnInit(): void {
    this.idEmpresa = this.baseFormService.getIdEmpresaLocalStorage();
  }

  onSubmit(){
    this.enviarDados(this.listaDepartamentosEnviados);
  }

  public cancelarIncluirDepartamento(){
    this.alertIncluirDepartamentoFechou.emit("cancelar");
    this.alertIncluirDepartamento = false
    this.novoDepartamento = null;
    this.listaDepartamento = [];
  }

  public fecharIncluirDepartamento(){
    this.alertIncluirDepartamento = false
    this.alertIncluirDepartamentoFechou.emit(this.alertIncluirDepartamento);
    this.novoDepartamento = null;
    this.listaDepartamento = [];
  }

  public adicionarDepartamentos(){
    if (this.novoDepartamento == null){
      this.mensagemErro = "Por favor, digite o nome do departamento.";
      this.abriAlertErro();
    }
    else{
      this.listaDepartamento.push(this.novoDepartamento.toUpperCase());
      this.listaDepartamentosEnviados.push(this.novoDepartamento.toUpperCase());
      this.novoDepartamento = null;
    }
  }

  public eventoAlertErroFechou(event: any){
    this.alertErro = event;
  }

  public abriAlertErro(){
    this.alertErro = true;
  }

  public eventoAlertSucessoFechou(event: any) {
    this.alertSucesso = event;
  }

  public abrirAlertSucesso() {
    this.alertSucesso = true;
  }

  public enviarDados(lista){
    if(this.listaDepartamentosEnviados.length > 0){
      this.dadosUsuarioService.createDepartmentByIdEmpresa(this.idEmpresa, lista)
      .pipe(take(1))
      .subscribe({
        next: (resposta: any) => {
          this.listaDepartamentosEnviados = [];
          this.resposta = resposta;
          this.abrirAlertSucesso();
          this.fecharIncluirDepartamento();
        },
        error: (error) => {
          console.log(error);
          this.mensagemErro = error.error.mensagem;
          this.abriAlertErro();
        }
      })
    }
    else{
      this.mensagemErro = "Por favor, adicione o departamento e selecione-o.";
      this.abriAlertErro();
    }
  }

  clickExclude( departamento ){
    if (this.listaDepartamento.includes(departamento)){
      this.procuraDepartamento = this.listaDepartamento.indexOf(departamento);
      this.listaDepartamento.splice ( this.procuraDepartamento, 1 );

      if (this.listaDepartamentosEnviados.includes(departamento)){
        this.procuraDepartamento = this.listaDepartamentosEnviados.indexOf(departamento);
         this.listaDepartamentosEnviados.splice ( this.procuraDepartamento, 1 );
        }
     }
  }
}
